const ROMAN = ["I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X", "XI", "XII", "XIII"];

// The Quantum seal for one gate: a ring of 13 points with this gate's point lit, around its numeral.
export default function Seal({ g, earned, size = 88, testId }) {
  const gold = earned ? "#D9B47A" : "#5A4A3E";
  return (
    <svg data-testid={testId} data-earned={earned ? "yes" : "no"} viewBox="0 0 100 100" width={size} height={size} role="img" aria-label={`Gate ${g + 1} seal${earned ? "" : " (not yet earned)"}`}>
      {earned && <circle cx="50" cy="50" r="46" fill="#C2414F" opacity="0.14" />}
      <circle cx="50" cy="50" r="44" fill="none" stroke={gold} strokeWidth="1" />
      <circle cx="50" cy="50" r="38" fill="none" stroke={gold} strokeWidth="0.5" strokeDasharray="1.5 3" />
      <ellipse cx="50" cy="50" rx="30" ry="11" fill="none" stroke={earned ? "#E8838E" : "#4A3A34"} strokeWidth="0.8" transform={`rotate(${-28 + g * 9} 50 50)`} />
      {ROMAN.map((_, k) => {
        const a = -Math.PI / 2 + (k * 2 * Math.PI) / 13;
        const lit = k === g;
        return <circle key={k} cx={50 + 41 * Math.cos(a)} cy={50 + 41 * Math.sin(a)} r={lit ? 2.6 : 1.3} fill={lit && earned ? "#C2414F" : gold} />;
      })}
      <text x="50" y="56" textAnchor="middle" fontFamily="Georgia, serif" fontSize="17" fill={earned ? "#F2E8DF" : "#6E5E52"}>{ROMAN[g]}</text>
    </svg>
  );
}
